// Archivo About.js actualizado

import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/AboutStyles.css";

const About = () => {
  const imagePath = `${process.env.PUBLIC_URL}/images/userImages`;
  const iconPath = `${process.env.PUBLIC_URL}/images/icons`;

  return (
    <main>
      {/* Contenedor del Navbar */}
      <div className="navbar-placeholder"></div>

      {/* Sección 1: Sobre Nosotros */}
      <section className="unique-about-us-section">
        <div className="container-fluid">
          <div className="row align-items-center">
            {/* Contenedor de texto */}
            <div className="col-md-6 unique-text-section unique-text-start">
              <h1 className="unique-section-number">01</h1>
              <h2 className="unique-section-title">Sobre Nosotros</h2>
              <p className="unique-section-description">
                Somos una constructora con más de 15 años de experiencia en el
                mercado, creando proyectos arquitectónicos y urbanísticos que
                combinan funcionalidad y estilo. Nos especializamos en ofrecer
                soluciones personalizadas para nuestros clientes, garantizando
                calidad e innovación.
              </p>
            </div>

            {/* Contenedor de imagen */}
            <div className="col-md-6 unique-image-section">
              <img
                src={`${imagePath}/who.jpg`}
                alt="Sobre Nosotros"
                className="img-fluid unique-rounded-image"
              />
            </div>
          </div>

          {/* Fila de estadísticas */}
          <div className="row unique-stats-row text-center">
            <div className="col-md-3 unique-stats-item">
              <h3 className="unique-stats-number">15</h3>
              <p className="unique-stats-label">Años en el mercado</p>
            </div>
            <div className="col-md-3 unique-stats-item">
              <h3 className="unique-stats-number">185</h3>
              <p className="unique-stats-label">Proyectos únicos</p>
            </div>
            <div className="col-md-3 unique-stats-item">
              <h3 className="unique-stats-number">110</h3>
              <p className="unique-stats-label">Colaboradores</p>
            </div>
            <div className="col-md-3 unique-stats-item">
              <h3 className="unique-stats-number">+5</h3>
              <p className="unique-stats-label">Arquitectos internacionales</p>
            </div>
          </div>
        </div>
      </section>


      {/* Sección 2: Qué Hacemos */}
      <section className="about-container">
        <div className="row align-items-center">
          {/* Contenedor de la imagen */}
          <div className="col-md-6 image-container">
            <div className="vertical-image-box">
              <img
                src={`${imagePath}/what.jpg`}
                alt="Diseño Interior"
                className="vertical-image"
              />
            </div>
          </div>

          {/* Contenedor de texto */}
          <div className="col-md-6 text-container">
            <p className="section-subtitle">02</p>
            <h1 className="section-title">Qué Hacemos</h1>
            <p className="section-description">
              Ofrecemos una gama completa de servicios en el sector de la
              construcción, incluyendo arquitectura, diseño interior, mobiliario y
              consultoría. Nuestro enfoque está en crear espacios que combinen
              funcionalidad, innovación y estilo.
            </p>
            <p className="section-description">
              Nos especializamos en proyectos residenciales y comerciales,
              brindando soluciones personalizadas para satisfacer las necesidades
              específicas de nuestros clientes.
            </p>
          </div>
        </div>
      </section>

      {/* Sección 3: Novedades */}
      <section className="novedades-section">
        <div className="container">
          {/* Título de la sección */}
          <h2 className="novedades-title">Blog</h2>
          <p className="novedades-subtitle">Algunas de nuestras últimas publicaciones</p>

          {/* Fila de publicaciones */}
          <div className="row">
            {/* Artículo 1 */}
            <div className="col-md-4">
              <div className="novedades-card">
                <img
                  src={`${imagePath}/arq.jpg`}
                  alt="Artículo 1"
                  className="novedades-image"
                />
                <div className="novedades-content">
                  <span className="novedades-category">Arquitectura</span>
                  <h3 className="novedades-title-card">Explorando nuevas tendencias</h3>
                  <p className="novedades-date">01 de Enero, 2023</p>
                  <p className="novedades-description">
                    Descubre cómo las tendencias modernas están cambiando el diseño
                    arquitectónico en todo el mundo.
                  </p>
                </div>
              </div>
            </div>

            {/* Artículo 2 */}
            <div className="col-md-4">
              <div className="novedades-card">
                <img
                  src={`${imagePath}/inno.jpg`}
                  alt="Artículo 2"
                  className="novedades-image"
                />
                <div className="novedades-content">
                  <span className="novedades-category">Innovación</span>
                  <h3 className="novedades-title-card">Materiales sostenibles</h3>
                  <p className="novedades-date">15 de Enero, 2023</p>
                  <p className="novedades-description">
                    Aprende cómo los materiales ecológicos están revolucionando la
                    construcción.
                  </p>
                </div>
              </div>
            </div>

            {/* Artículo 3 */}
            <div className="col-md-4">
              <div className="novedades-card">
                <img
                  src={`${imagePath}/des.jpg`}
                  alt="Artículo 3"
                  className="novedades-image"
                />
                <div className="novedades-content">
                  <span className="novedades-category">Diseño</span>
                  <h3 className="novedades-title-card">Espacios minimalistas</h3>
                  <p className="novedades-date">25 de Enero, 2023</p>
                  <p className="novedades-description">
                    Los beneficios de los espacios minimalistas en proyectos
                    residenciales.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Botón para ver más publicaciones */}
          <div className="text-center mt-4">
            <Link to="/projects" className="btn btn-outline-light novedades-btn">
              Ver más
            </Link>
          </div>
        </div>
      </section>

      {/* Sección Visión, Valores e Historia */}
      <section className="about-section py-5 custom-bg">
        <div className="container">
          <div className="row">
            {/* Visión */}
            <div className="col-lg-4 text-center mb-4">
              <img
                src={`${iconPath}/vision.png`}
                alt="Visión"
                className="rounded-circle about-circle mb-3"
              />
              <h2 className="fw-normal">Visión</h2>
              <p className="vision-text">
                Convertirnos en líderes del sector, ofreciendo proyectos que
                transformen comunidades y mejoren la calidad de vida.
              </p>
            </div>

            {/* Valores */}
            <div className="col-lg-4 text-center mb-4">
              <img
                src={`${iconPath}/valores.png`}
                alt="Valores"
                className="rounded-circle about-circle mb-3"
              />
              <h2 className="fw-normal">Valores</h2>
              <p className="valores-text">
                Ética, responsabilidad social, excelencia y compromiso con el
                medio ambiente.
              </p>
            </div>

            {/* Historia */}
            <div className="col-lg-4 text-center mb-4">
              <img
                src={`${iconPath}/historia.png`}
                alt="Historia"
                className="rounded-circle about-circle mb-3"
              />
              <h2 className="fw-normal">Historia</h2>
              <p className="historia-text">
                Más de 20 años de experiencia desarrollando proyectos que
                impactan positivamente a las comunidades.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;